import { apiSlice } from '../api-slice';

type GenerateExamLinkParams = {
  userId: number; // UserInitialState.id
  scheduleId: number; // EntranceTest.scheduleId
};

type ExamLinkResponse = string;

const baseUrl = `${process.env.REACT_APP_APPLICATIONS_MANAGER_API_URL}/support`;

export const supportApi = apiSlice.injectEndpoints({
  endpoints: builder => ({
    generateExamLink: builder.query<ExamLinkResponse, GenerateExamLinkParams>({
      query: ({ userId, scheduleId }) => ({
        url: `${baseUrl}/generate-exam-link`,
        method: 'GET',
        params: {
          userId: userId,
          scheduleId: scheduleId,
        },
        responseHandler: 'text',
      }),
      transformResponse: (response: string) => response,
    }),
  }),
});
